import { useState, type FormEvent } from 'react';
import { useAuth } from '../context/AuthContext';

export function LoginPage() {
  const { login, error, loading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await login({ email, password });
    } catch {
      // Error is handled by context
    }
  };

  return (
    <div className="login-screen">
      <div className="login-visual">
        <div className="brand">
          <div className="brand-mark">MG</div>
          <div>
            <strong style={{ color: 'white', fontSize: '1.25rem' }}>MGBotISP</strong>
            <span style={{ color: '#90a4ae', display: 'block', fontSize: '0.857rem' }}>
              Atendimento profissional para provedores
            </span>
          </div>
        </div>
        <div>
          <h1>Centralize bots, filas, tickets e atendimento humano.</h1>
          <p>
            Plataforma profissional de atendimento multicanal para provedores de internet.
            Gerencie conversas do Telegram e WhatsApp com triagem inteligente,
            filas por setor e templates personalizados.
          </p>
        </div>
        <div className="login-highlights">
          <span>Telegram Bot API</span>
          <span>WhatsApp Cloud API</span>
          <span>Triagem automática por IA</span>
          <span>Filas por departamento</span>
          <span>Integração SGP</span>
        </div>
      </div>

      <form className="login-card" onSubmit={handleSubmit}>
        <div>
          <h2>Acessar plataforma</h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: '0.929rem', marginTop: 4 }}>
            Faça login com suas credenciais de acesso.
          </p>
        </div>

        <label>
          E-mail
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="seu@email.com"
            required
            autoFocus
            autoComplete="username"
          />
        </label>

        <label>
          Senha
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Sua senha"
            required
            autoComplete="current-password"
          />
        </label>

        <button type="submit" disabled={loading}>
          {loading ? 'Entrando...' : 'Entrar'}
        </button>

        <small>{error || ' '}</small>
      </form>
    </div>
  );
}
